/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './anonymous-consent-dialog.component';
export * from './anonymous-consents-dialog.module';
